import React from "react";
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

/** FIN / ödəniş modalı — yalnız parent state ilə idarə olunur (URL-dən asılı deyil). */
const MonthlyPayment = ({
  onRequestClose,
  children,
  style,
  isOpen = false,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      style={style}
    >
      {children}
    </ReactModal>
  );
};

export default MonthlyPayment;
